import React from 'react';
import LocationTemplate from './LocationTemplate';

const KinstonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Kinston"
      stateName="North Carolina"
      countyName="Lenoir"
      zipCodes={["28501", "28502", "28503", "28504"]}
      latitude={35.2627}
      longitude={-77.5816}
      population={19900}
      historicalFact="Originally established as 'Kingston' in 1762 in honor of King George III; name changed after the Revolutionary War."
      nearbyTowns={[
        "Goldsboro, NC",
        "New Bern, NC",
        "Greenville, NC",
        "Wilson, NC",
        "Mount Olive, NC",
        "Washington, NC",
        "La Grange, NC",
        "Pink Hill, NC"
      ]}
    />
  );
};

export default KinstonPage;